var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 25.5H27.0975L26.4675 24.8925C28.6725 22.3275 30 18.9975 30 15.375C30 7.2975 23.4525 0.75 15.375 0.75C7.2975 0.75 0.75 7.2975 0.75 15.375C0.75 23.4525 7.2975 30 15.375 30C18.9975 30 22.3275 28.6725 24.8925 26.4675L25.5 27.0975V28.875L36.75 40.1025L40.1025 36.75L28.875 25.5ZM15.375 25.5C9.7725 25.5 5.25 20.9775 5.25 15.375C5.25 9.7725 9.7725 5.25 15.375 5.25C20.9775 5.25 25.5 9.7725 25.5 15.375C25.5 20.9775 20.9775 25.5 15.375 25.5Z",
    fill: "#AD9078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifyingGlass.32c7f7a03978f086d0ad1557a016e1a3.svg";
export { ForwardRef as ReactComponent };